import { Container, CssBaseline } from "@material-ui/core";
import DashboardAppBar from "../../components/UI/AppBar/AppBar";
import Header from "../../components/UI/Header";
import { Helmet } from "react-helmet";

export default function Layout(props) {
  return (
    // React Material Drawer will go here
    <>
      <Helmet>
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-M94TB8V');
        `}
        </script>
      </Helmet>
      <DashboardAppBar />
      <Header />
      <CssBaseline />
      <Container maxWidth="lg">
        <div>{props.children}</div>
      </Container>
    </>

    // Footer will go here
  );
}
